import React from 'react'
import Form from 'react-bootstrap/Form'
import _ from 'lodash'

export default function SelectInput({ label, placeholder, validation = [], required, className = '', dataCy = "", ...props }) {
  let isRequired = required || (validation.includes('required') && !(validation.includes('skip') || validation.includes('optional')));

  const dataProps = Object.keys(props).reduce((acc, key) => {
    if (key.startsWith('data-')) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
  return (
    <div className="form-group w-100">
      <div className={_.uniq(["input-block", ...className.split(' ')]).join(' ')}>
        {label && <label className="input-label">
          <span>{label || ''} {isRequired ? <span className='text-danger'>*</span> : null}</span>
        </label>}
        <Form.Select
          data-cy={dataCy || props['data-cy']}
          aria-label="Default select example"
          className={`form-control-input ${props.customClassName || ''}`}
          value={props.value || ''}
          disabled={props.disabled || false}
          onChange={props.onChange}
          name={props.name}
          {...dataProps}
        >
          {(placeholder || label) && <option className="my-2" value="" disabled>Select {placeholder || label}</option>}
          {(props.items || []).map((option) => {
            return <option value={option.value} key={option.key || option.label} disabled={option.isDisabled || option.disabled} data-cy={option.key || option.label} data-type={option.type?.toLowerCase() || ''}>{option.key || option.label}</option>
          })}
        </Form.Select>
        {props.error && props.touched && <small className="float-start text-danger">
          {props.error}
        </small>}
      </div>
    </div>
  )
}
